import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LeadChevronRegular from './lead-chevron-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LeadChevronRegular {...validProps} />;
}

SvgComponent.iconName = 'lead-chevron-regular';

export const LeadChevronRegularIcon = svgIconWrapper(SvgComponent);
